import { mergeStyles } from '@fluentui/react';

const KnowledgeBaseContainerStyle = mergeStyles({
  width: '100%',
  height: '100%',
  background: '#F5F5F5',
  '.ms-Button--primary': {
    float: 'right'
  },
  '.ms-Button--default': {
    float: 'right'
  }
});
const KnowledgeBaseMinStyle = mergeStyles({
  width: '100%',
  minHeight: '100%',
  boxSizing: 'border-box',
  position:"absolute",
  overflow:'auto',
  background: '#F5F5F5',
  borderTop: '1px solid #f5f5f5',
  ".addBookmark":{
    'a:hover':{
      fontWeight: '600',
    },
  },
  fontStyle: 'normal',
  fontSize: '14px'
});
const KnowledgeBaseSearchStyle = mergeStyles({
  position:"fixed",
  zIndex:"1",
  top:"0",
  width:'100%',
  height: '55px',
  lineHeight: '55px',
  background: '#F5F5F5',
  borderLeft: '1px solid #E1DFDD',
  display: 'flex',
  // justifyContent: ' space-between',
  alignItems: 'center',
  justifyContent:"space-between",
  padding: '0 15px 0 20px',
  borderBottom:"solid 1px #ebebeb"
});
const KnowledgeBaseListBoxStyle = mergeStyles({
  padding: '20px',
  boxSizing: 'border-box',
  width: '100%',
  display:'flex',
  justifyContent:"center",
  flexWrap:"wrap"
});
const listBox = mergeStyles({
    width:"90%",
});
const TooltipText = mergeStyles({
  display: 'inline',
  padding:'0px 8px',
  width: '64px',
  fontStyle: 'normal',
fontWeight: '400',
fontSize: '12px',
  height: '24px',
  lineHeight:"24px",
  background:'#EBEBEB',
  borderRadius: '4px',
  position: 'absolute',top: '12px', right: '12px',
});
const KnowledgeBaseListBox2Style = mergeStyles({
  padding: '20px',
  boxSizing: 'border-box',
  width: '100%',
  background: '#F5F5F5',
  display: 'flex',
  alignItems:"center",
  flexDirection: 'column'
});
const KnowledgeBaseListOneStyle = mergeStyles({
  marginLeft:"30px",
  marginTop:"25px",
  width:"30%",
  padding: '16px',
  height: '104px',
  borderRadius: '4px',
  border:"none",
  display:"inline-block",
  filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.12)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.14))',
  '.ms-DocumentCardTitle': {
    padding: '0',
    fontSize: '14px',
    fontWeight: '600',
  },
  '.ms-DocumentCardDetails': {}
});
const KnowledgeBaseListOne2Style = mergeStyles({
  borderRadius: '5px',
  background: '#fff',
  margin: '0 45px 15px 45px',
  padding: '16px',
  minHeight: '76px',
  width:"64%",
  alignItems: 'center',
  justifyContent:"center",
 filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.12)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.14))',
  '.BaseListOneTop': {
    width: '100%',
    display: 'flex',
    fontSize: '14px',
    justifyContent: ' space-between',
    p: {
      flex: '1'
    },
    div: {
      width: '50px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  '.BaseListOneBom': {
    fontSize: '12px',
    paddingRight: '50px'
  }
});
const KnowledgeBaseBoxFootStyle = mergeStyles({
  display: 'flex',
  justifyContent: ' space-between',
  alignItems: 'center'
});
const ButtonNo = mergeStyles({
  '.ms-Button-menuIcon': {
    display: 'none'
  }
});

const KnowledgeBaseModifyBoxStyle = mergeStyles({
  width: '100%',
  border: 'hidden',
  padding: '5px 20px',
  display: 'flex',
  zIndex:"4",
  background:"white",
  position:"absolute",
  marginLeft:"-16px",
  marginTop:"-16px",
  flexDirection: 'column',
  '.modifyTop': {
    div: {
      flex:"1",
      border: 'hidden'
    },
    input: {
      background:"#F5F5F5",
    }
  },
  '.modifyBom': {
    whiteSpace: 'pre-wrap',
    marginTop: '10px',
    flex: '1',
    div: {
      border: 'hidden',
    },
    '.ms-TextField-field': {
      height: '100%',
      background:"#F5F5F5",
      borderRadius: '5px'
    }
  }
});
const KnowledgeBaseModifyBoxStyle2 = mergeStyles({
  width: '100%',
  border: 'hidden',
  padding: '5px 20px',
  display: 'flex',
  zIndex:"4",
  flexDirection: 'column',
  '.modifyTop': {
    div: {
      flex:"1",
      border: 'hidden'
    },
    input: {
      background:"#F5F5F5",
    }
  },
  '.modifyBom': {
    whiteSpace: 'pre-wrap',
    marginTop: '10px',
    flex: '1',
    div: {
      border: 'hidden',
    },
    '.ms-TextField-field': {
      height: '100%',
      background:"#F5F5F5",
      borderRadius: '5px'
    }
  }
});



export {
  KnowledgeBaseContainerStyle,
  KnowledgeBaseMinStyle,
  KnowledgeBaseSearchStyle,
  KnowledgeBaseListBoxStyle,
  KnowledgeBaseListBox2Style,
  KnowledgeBaseListOneStyle,
  KnowledgeBaseListOne2Style,
  KnowledgeBaseBoxFootStyle,
  KnowledgeBaseModifyBoxStyle,
  KnowledgeBaseModifyBoxStyle2,
  ButtonNo,
  listBox,
  TooltipText
};
